module.exports = __webpack_public_path__ + "static/media/eclass.c677b115.svg";